export const ConfigTR={
cfgDBDescription:{en:'cfgDBDescription',cs:'cfgDBDescription',dataType:'string'},
cfgConnectionString:{en:'cfgConnectionString',cs:'cfgConnectionString',dataType:'string'},
cfgOutputDirectory:{en:'cfgOutputDirectory',cs:'cfgOutputDirectory',dataType:'string'},
cfgSplitLogFileDays:{en:'cfgSplitLogFileDays',cs:'cfgSplitLogFileDays',dataType:'string'},
cfgTimeZoneID:{en:'cfgTimeZoneID',cs:'cfgTimeZoneID',dataType:'string'},
cfgUploadedFilesDirectory:{en:'cfgUploadedFilesDirectory',cs:'cfgUploadedFilesDirectory',dataType:'string'}
}